import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RotteService {

  public isActiveGaia: BehaviorSubject<any> = new BehaviorSubject({value:false,selected:''});

  constructor() { }
}
